import { Pipe, PipeTransform } from '@angular/core';

/**
 * Strips HTML markup from a string and returns readable plain text.
 * Intended for compact previews/snippets where rendered formatting is undesirable
 * (e.g. inbox list rows). Tags are replaced with spaces so block elements do not
 * glue adjacent words together; HTML entities are decoded and whitespace collapsed.
 */
@Pipe({
  name: 'stripHtml',
})
export class StripHtmlPipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    if (!value) {
      return '';
    }

    // Replace tags with a space first, so "…staat.</p><p>IP-adres:" becomes "…staat. IP-adres:".
    const withoutTags = value.replace(/<[^>]+>/g, ' ');

    // Decode HTML entities via the browser. Tags are already removed, so nothing executes.
    const decoded = new DOMParser().parseFromString(withoutTags, 'text/html').body.textContent ?? '';

    return decoded.replace(/\s+/g, ' ').trim();
  }
}
